import { Autocomplete, styled, TextField } from '@mui/material';
import { sortBy } from 'lodash-es';
import React from 'react';
import { getAllISOCodes } from 'iso-country-currency';
import { Controller, useFormContext } from 'react-hook-form';
import Input from '@ui/Input';
import Select from '@ui/Select';
import TextArea from '@ui/TextArea';
import { authorizedServerFetch } from 'actions/server.actions';

function EditNpoProfileForm(props) {
  const { onSubmit, nonProfit } = props;

  const formMethods = useFormContext();
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = formMethods;
  const [causes, setCauses] = React.useState([]);

  // fetch all causes
  React.useEffect(() => {
    const fetchCauses = async () => {
      const { data: causeData } = await authorizedServerFetch('causes/company');
      const { all } = causeData?.data;
      setCauses(sortBy(all, 'cause_title'));
    };
    fetchCauses();
  }, []);

  return (
    <div className="flex w-full flex-1 flex-col gap-12">
      <form
        id="update-np-overview-tab"
        className="flex flex-col gap-6"
        onSubmit={handleSubmit((data) => onSubmit(data))}>
        <Controller
          name="website"
          control={control}
          render={({ field: { ref, ...rest } }) => (
            <Input
              label="WEBSITE"
              required
              {...rest}
              error={errors.website?.message}
            />
          )}
        />

        <div className="flex gap-6">
          <div className="flex w-1/2 flex-col">
            <Controller
              name="address"
              control={control}
              render={({ field: { ref, ...rest } }) => (
                <Input
                  label="ADDRESS"
                  required
                  {...rest}
                  error={errors.address?.message}
                />
              )}
            />
          </div>
          <div className="flex w-1/2 flex-col">
            <Controller
              name="city"
              control={control}
              render={({ field: { ref, ...rest } }) => (
                <Input
                  label="CITY"
                  required
                  {...rest}
                  error={errors.city?.message}
                />
              )}
            />
          </div>
        </div>

        <div className="flex gap-6">
          <div className="flex w-1/2 flex-col">
            <Controller
              name="state"
              control={control}
              render={({ field: { ref, ...rest } }) => (
                <Input
                  label="STATE"
                  required
                  {...rest}
                  error={errors.state?.message}
                />
              )}
            />
          </div>

          <div className="flex w-1/2 flex-col">
            <Controller
              control={control}
              name="country"
              render={({ field: { ref, ...rest } }) => (
                <Select
                  label="COUNTRY"
                  required
                  {...rest}
                  options={getAllISOCodes().map((item) => ({
                    id: item.countryName,
                    label: item.countryName,
                  }))}
                  error={errors?.country?.message}
                  // value={formMethods.getValues('country')}
                />
              )}
            />
          </div>
        </div>

        <div className="flex gap-6">
          <div className="flex w-1/2 flex-col">
            <Controller
              name="zipcode"
              control={control}
              render={({ field: { ref, ...rest } }) => (
                <Input
                  label="ZIP CODE"
                  required
                  {...rest}
                  error={errors.zipcode?.message}
                />
              )}
            />
          </div>
          <div className="flex w-1/2 flex-col">
            <Controller
              name="ein"
              control={control}
              render={({ field: { ref, ...rest } }) => (
                <Input
                  label="TAX ID"
                  required
                  {...rest}
                  error={errors.ein?.message}
                />
              )}
            />
          </div>
        </div>

        <Controller
          name="description"
          control={control}
          render={({ field: { ref, ...rest } }) => (
            <TextArea
              required
              label="MISSION & CAUSE"
              placeholder=""
              multiline="true"
              rows={4}
              {...rest}
              error={errors.description?.message}
            />
          )}
        />

        <Controller
          name="slogan"
          control={control}
          render={({ field: { ref, ...rest } }) => (
            <TextArea
              required
              label="SLOGAN"
              placeholder=""
              multiline="true"
              rows={4}
              {...rest}
              error={errors.slogan?.message}
            />
          )}
        />

        {/* {nonProfit?.country !== 'US' && ( */}
          <Controller
            name="donationUrl"
            control={control}
            render={({ field: { ref, ...rest } }) => (
              <Input
                label="DONATION URL"
                {...rest}
                error={errors.donationUrl?.message}
              />
            )}
          />
        {/* )} */}

        <Controller
          name="causes"
          control={control}
          defaultValue={[]}
          render={({ field: { onChange, value } }) => (
            <Autocomplete
              multiple
              id="causes"
              options={causes}
              value={value}
              onChange={(event, newValue) => {
                onChange(newValue);
              }}
              getOptionLabel={(option) => option.cause_title}
              isOptionEqualToValue={(option, val) => option.id === val.id}
              fullWidth
              ChipProps={{
                color: 'secondary',
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  placeholder="Causes you support"
                  label="CAUSE CATEGORY"
                  className="text-17 font-medium text-text-primary"
                  fullWidth
                  register={register('causes')}
                  helperText={errors.causes?.message || ''}
                  error={!!errors.causes}
                />
              )}
            />
          )}
        />
      </form>
    </div>
  );
}

export default EditNpoProfileForm;
